import { render } from "./twelve-book.vue?vue&type=template&id=50d531cc"
import script from "./twelve-book.vue?vue&type=script&lang=js"
export * from "./twelve-book.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__